import { useState } from "react";
import { useCreateBulkDemos, useGetDemos, useSendMeetingInvite } from "../hooks/useDemoApi";
import { DemoEntryForm } from "../components/demos/DemoEntryForm";
import { DemoList } from "../components/demos/DemoList";
import Container from "../components/ui/Container";
import Loader from "../components/ui/Loader";
import { SendInviteModal } from "../components/demos/SendInviteModal";
import { useAuth } from "../hooks/AuthContext";
import { toast } from "react-toastify";

export default function DemoCreatePage() {
  const [page, setPage] = useState(1);
  const limit = 10;

  const { user } = useAuth();
  const isEmployee = user?.role === "employee";

  // Fetch demos using React Query
  const { data: demoData, isLoading: isLoadingDemos } = useGetDemos(page, limit);

  const { mutate: createDemos, isLoading: isCreating } = useCreateBulkDemos();
  const { mutate: sendInvites, isPending: isSendingInvites } = useSendMeetingInvite();

  const [isInviteModalOpen, setInviteModalOpen] = useState(false);
  const [demosForInvite, setDemosForInvite] = useState([]);

  // Demo creation
  const handleFormSubmit = (formData) => {
    createDemos(
      { demos: formData.demos },
      {
        onSuccess: (data) => {
          // data here is the resolved value returned by your mutation
          const message = data?.message || "Function submitted successfully!";
          toast.success(message);
        },
        onError: () => toast.error("Failed to create demos."),
      }
    );
  };

  // Pagination handler
  const onPageChange = (newPage) => {
    if (newPage > 0 && newPage <= demoData?.pages) setPage(newPage);
  };

  // Invite modal
  const handleOpenInviteModal = (selectedIds) => {
    if (!selectedIds.length) return;
    const selectedDemos = demoData?.demos?.filter((demo) => selectedIds.includes(demo._id));
    setDemosForInvite(selectedDemos);
    setInviteModalOpen(true);
  };

  const handleInviteSubmit = (formData) => {
    const demoIds = demosForInvite.map((d) => d._id);
    // const demoType = demosForInvite[0]?.type;
    const payload = { demoIds, ...formData, sender: user?.email };

    sendInvites(payload, {
    onSuccess: (response) => {
        // response is the object returned by the API
        const message = response?.message || "Function submitted successfully!";
        toast.success(message);
        setInviteModalOpen(false)
      },
      onError: (error) => {
        const message =
          error.response?.data?.message || "Failed to create demos.";
        toast.error(message);
      },
    });
  };

  return (
    <Container>
      <h1 className="text-xl font-bold mb-2">Create New Function</h1>

      <DemoEntryForm onSubmit={handleFormSubmit} isLoading={isCreating} />

      <hr className="my-3" />

      <h2 className="text-xl font-semibold mb-4">Pending Function</h2>

      {isLoadingDemos ? (
        <Loader />
      ) : (
        <DemoList
          demos={demoData?.demos}
          statusFilter={["pending"]}
          isHrView={!isEmployee} // HR/Admin view if not employee
          onSendInviteClick={handleOpenInviteModal}
          paginationData={{ page, pages: demoData?.pages }}
          onPageChange={onPageChange}
        />
      )}

      {isInviteModalOpen && (
        <SendInviteModal
          demos={demosForInvite}
          onClose={() => setInviteModalOpen(false)}
          onSubmit={handleInviteSubmit}
          isLoading={isSendingInvites}
        />
      )}
    </Container>
  );
}
